import { Link } from "react-router-dom";
import { HelpCircle } from "lucide-react";

import { Button } from "@/shared/components/ui/button";
import { CardContainer } from "@/shared/components/CardContainer";
import { MobileHeader } from "@/shared/components/MobileHeader";
import { ResponsiveViewWrapper } from "@/shared/components/ResponsiveViewWrapper";

/** Handles unknown client-side routes inside the mobile device shell. */
export function NotFoundPage() {
  return (
    <ResponsiveViewWrapper
      maxMobileWidth={430}
      className="bg-frame-surface"
      scrollable={false}
      aria-label="صفحه یافت نشد"
    >
      <MobileHeader
        title="کایرسافت"
        subtitle="خطای ۴۰۴"
        showBack={true}
        backTo="/"
      />

      <div
        className="flex flex-1 flex-col items-center justify-center p-6 text-center select-none"
        dir="rtl"
      >
        <CardContainer
          variant="soft"
          className="w-full space-y-4 py-8 text-center"
        >
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-400">
            <HelpCircle className="h-7 w-7" aria-hidden="true" />
          </div>
          <div className="space-y-1">
            <span className="text-brand font-mono text-xs font-bold">404</span>
            <h2 className="text-slate-dark text-base font-bold">
              صفحه مورد نظر یافت نشد
            </h2>
            <p className="text-slate-muted mx-auto max-w-xs text-xs">
              آدرس وارد شده معتبر نیست یا صفحه به نشانی دیگری منتقل شده است.
            </p>
          </div>
          <div className="pt-2">
            <Button
              asChild
              variant="brand"
              size="touch"
              className="w-full text-xs font-bold"
            >
              <Link to="/">بازگشت به صفحه اصلی</Link>
            </Button>
          </div>
        </CardContainer>
      </div>
    </ResponsiveViewWrapper>
  );
}
